import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getSupportCode } from './utils.js'
import tts from '../../lib/TTS.js'
import FocusableButtonTS from '../../components/FocusableButton/FocusableButtonTS'

const COMPONENT_FOCUS_KEY = 'LIVE_TV_UNAVAILABLE'
const CLOSE_BUTTON_FOCUS_KEY = `${COMPONENT_FOCUS_KEY}_CLOSE_BUTTON`

type LiveTVUnavailableProps = {
  callSign: string
  navigate: any
}

const LiveTVUnavailable = ({ callSign, navigate }: LiveTVUnavailableProps) => {
  const [supportCode, setSupportCode] = useState<string>('')

  useEffect(() => {
    getSupportCode().then((supportCode) => {
      setSupportCode(supportCode)
    })
  }, [])

  const handleEnterPress: VoidFunction = () => navigate('/home')

  const handleFocus: VoidFunction = () =>
    tts.addTextToRead(
      `Live TV Not Available .... The ${callSign} Livestream is not available because you are not currently in the station broadcast coverage area. For more information, visit: www.pbs.org/livestreamFAQ .... Support Code: ${supportCode} .... Focus on Close Button.`
    )

  return (
    <div className="livestream-screen__unavailable">
      <h1 className="livestream-screen__unavailable__title">
        Live TV Not Available
      </h1>
      <p className="livestream-screen__unavailable__message">
        The {callSign} Livestream is not available because you are not currently
        in the station broadcast coverage area. For more information, visit:
        www.pbs.org/livestreamFAQ
      </p>
      {supportCode && <p>Support Code: {supportCode}</p>}
      <FocusableButtonTS
        onEnterPress={handleEnterPress}
        onFocus={handleFocus}
        className="livestream-screen__unavailable__close-button"
        focusKey={CLOSE_BUTTON_FOCUS_KEY}
      >
        Close
      </FocusableButtonTS>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    callSign: state.station.call_sign,
  }
}

export default connect(mapStateToProps, null)(LiveTVUnavailable)
